import {
  Path,
  FieldError,
  Control,
  Controller,
  FieldValues,
} from "react-hook-form";

export type InputComponentProps<Type extends FieldValues> = {
  APIgetValue?: string;
  label?: string;
  placeholder?: string;
  helperText?: string;
  success?: boolean;
  errors?: FieldError;
  disabled?: boolean;
  onChange?: (value: string | number) => void;
  value?: any;
  isRequired?: boolean;
  dynamicRows?: number;
  name: Path<Type>;
  control: Control<Type, any>;
  classNameAdded?: any;
  latestReceivedValue?: string;
  editable?: boolean;
  labelFlex?: boolean;
  w_full?: boolean;
  defaultValue?: string;
};
function TextareaComponent<Type extends FieldValues>(
  props: InputComponentProps<Type>
) {
  let baseClasses = `resize-vertical max-h-[200px] `;
  const getInputClassName = () => {
    if (props.success) {
      return ` text-green-600 border-green-500 bg-green-100 focus:text-green-700`;
    } else if (props.errors) {
      return ` text-red-600 border-red-500 bg-red-100 focus:text-red-700`;
    } else if (props.disabled) {
      return ` cursor-not-allowe border-gray-300 bg-gray-50 opacity-50`;
    } else {
      return ` focus:text-gray-900 bg-gray-50 text-gray-900 border-gray-300`;
    }
  };
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({ field }) => (
        <div
          className={`flex ${props.w_full ? `w-full` : ``} ${
            props.labelFlex ? "flex-row" : "flex-col"
          } justify-between`}
        >
          <label
            htmlFor={props.name}
            className="mb-2 text-gray-900 text-Body-OneLine/14/Regular "
          >
            {props.label}
            {props.isRequired && <span className="text-red-500">*</span>}
          </label>
          <textarea
            {...field}
            defaultValue={props.defaultValue}
            className={`${baseClasses} ${getInputClassName()} ${
              props.classNameAdded
            } block w-full pr-4 px-4 py-2 border rounded-lg focus:outline-none focus:border-primary-700`}
            id={props.name}
            rows={props.dynamicRows}
            placeholder={props.placeholder}
            value={field.value}
            onChange={(e) => {
              const value = e.target.value;
              field.onChange(value);
              if (props.onChange) {
                props.onChange(value);
              }
            }}
            readOnly={!props.editable}
          />
          {props.errors && props.errors.message ? (
            <p className={`text-Body-OneLine/14/Regular text-red-600`}>
              {props.errors.message}
            </p>
          ) : (
            <p className={`text-Body-OneLine/14/Regular text-gray-500`}>
              {props.helperText ? (
                props.helperText
              ) : (
                <span className="invisible">invisible</span>
              )}
            </p>
          )}
        </div>
      )}
    />
  );
}

export default TextareaComponent;
